import { type Localisation } from "./en";

export const italian: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "Lo schermo è attivo ma nessun token è presente",
    "Network error": "Errore di rete",
    "Checking display status": "Verifica dello stato del display",
    "Failed to get display status": "Impossibile ottenere lo stato del display",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Se il problema persiste, contatta l'amministratore di Teamworks.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Questo di solito è dovuto a un errore di rete durante la configurazione del dispositivo. Reimposta il dispositivo utilizzando il pulsante qui sotto e riprova.",
    "Setup failed to complete": "La configurazione non è stata completata",
    "Please reset your device using the button below and try again.":
      "Ripristina il dispositivo utilizzando il pulsante qui sotto e riprova.",
  },
  ConfigProvider: {
    "Loading configuration": "Caricamento configurazione",
  },
  AppProvider: {
    Loading: "Caricamento",
    "No configuration selected": "Nessuna configurazione selezionata",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "Non siamo riusciti a trovare una configurazione per il codice fornito. Si prega di contattare l'amministratore di Teamworks.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Questo dispositivo è stato registrato, ma non è stata ancora impostata alcuna configurazione. Non preoccuparti, puoi aggiornare facilmente questo dispositivo nell'app di gestione dei display digitali.",
    "Network error: failed to load playlist":
      "Errore di rete: impossibile caricare la playlist",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...":
      "Ripristino in corso, si prega di attendere...",
  },
  UpdatesProvider: {
    "Checking for update": "Verifica aggiornamenti",
    "Downloading update": "Download dell'aggiornamento",
  },
  InteractionScreen: {
    "Loading...": "Caricamento...",
    "Press any key to begin": "Premi un tasto qualsiasi per iniziare",
    "No configurations assigned": "Nessuna configurazione assegnata",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Puoi assegnare una configurazione o una playlist da eseguire su questo dispositivo tramite l'app di gestione dei display digitali.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Scansiona il codice QR nella tua app fotocamera",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Pagina eventi {{count}} di {{total}}",
    Today: "Oggi",
    "All day": "Tutto il giorno",
    Tomorrow: "Domani",
  },
  ErrorScreen: {
    "Something went wrong": "Qualcosa è andato storto",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Ci scusiamo per l'inconveniente, i nostri ingegneri sono stati notificati e lavoreranno per risolvere il problema",
    "If this issue persists, please contact your account manager":
      "Se il problema persiste, contattare il proprio responsabile dell'account",
    "Reset device": "Ripristina dispositivo",
    "Your IP address may need to be permitted: {{ip}}":
      "Potrebbe essere necessario autorizzare il tuo indirizzo IP: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "L'app tentarà di ripristinare automaticamente in {{seconds}} secondi",
  },
  NextMatch: {
    days: "giorni",
    hours: "ore",
    minutes: "minuti",
    seconds: "secondi",
  },
  MediaContentCarosel: {
    "Media not found": "Media non trovati",
  },
  PlaylistProvider: {
    "Loading...": "Caricamento...",
    "Loading playlist": "Caricamento playlist",
  },
  ScreenFooter: {
    Hardcoded: "Codificato",
  },
  NotFoundLayout: {
    "Configuration not found": "Configurazione non trovata",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Nessun allenamento selezionato",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Seleziona un allenamento dalla scheda Digital Display in S&C per visualizzarlo qui",
  },
  WeatherWidget: {
    "Weather unavailable": "Meteo non disponibile",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Impossibile recuperare il menu",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "Impossibile recuperare la stazione di ristorazione",
    "Add ons will affect nutrition information":
      "Gli extra influenzeranno le informazioni nutrizionali",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Nessun dato meteorologico da mostrare, contatta il tuo amministratore di Teamworks.",
    Clear: "Sereno",
    Clouds: "Nuvoloso",
    Rain: "Pioggia",
    Drizzle: "Pioviggine",
    Thunderstorm: "Temporale",
    Snow: "Neve",
    Mist: "Nebbia",
    Smoke: "Fumo",
    Haze: "Foschia",
    Dust: "Polvere",
    Fog: "Nebbia densa",
    Sand: "Sabbia",
    Ash: "Cenere vulcanica",
    Squall: "Burrasca",
    Tornado: "Tornado",
  },
};
